<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details              
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->
              <router-link :to="{path: formPath}">
                  <v-btn color="success" fab small dark>
                    <v-icon>add</v-icon>
                  </v-btn>  
              </router-link>              
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table                
                :headers="complex.headers"               
                :items="complex.items"
                :loading="loading"
                :pagination.sync="pagination"
                :rows-per-page-items="[{text:'All','value':-1}]"
                hide-actions                
                item-key="id"                               
                v-model="complex.selected"
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.no }}</td>
                  <td>{{ props.item.name }}</td>  
                  <td>{{ props.item.kelurahan_id }}</td>
                  <td>{{ props.item.pt_l }}</td>
                  <td>{{ props.item.pt_p }}</td>
                  <td>
                    <router-link :to="{path:formPath, query: {id: props.item.id}}">
                        <v-btn depressed icon class="primary--text" small>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </router-link>                                          
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-text>
              <v-chip outline color="primary" style="float:left">Total &nbsp;<strong> {{count}}</strong></v-chip>                 
               <div class="text-xs-right">
                  <v-pagination
                    v-model="page"
                    v-bind:length="length"
                    v-bind:total-visible="5"
                    circle
                  ></v-pagination>
                </div>
            </v-card-text>
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import tps    from '@/apps/frc/models/Tps';    
import moment from 'moment';

var model = new tps();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        page     : 1,
        length   : 1,
        count    : 0,
        pagesize : 10,
        formPath : '/adm/tps/form',
        search   : '',
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: 'ID',   value: 'id'  },
              { text: 'No', value: 'no'},
              { text: 'Name', value: 'name'},
              { text: 'Kecamatan ID', value: 'kelurahan_id'},
              { text: 'PTL', value: 'pt_l'},
              { text: 'PTP', value: 'pt_p'},
              { text: 'Action', value: '', align:'left' },              
            ],
            items: []
        },
    }),  
    watch:{
        page(val){
          this.loading = true;
          model.all({page:val, 'TpsSearch[name]':this.search, 'TpsSearch[kelurahan_id]':this.search}).then(data => {      
              this.complex.items = data.data; 
              this.count   = data.count;
              this.length  = Math.ceil(this.count/this.pagesize);
              this.loading = false;
          }); 
        },
        search(val){
          setTimeout(()=>{
            if(val === this.search){
              this.loading = true;
              model.all({page:this.page, 'TpsSearch[name]':val, 'TpsSearch[kelurahan_id]':val}).then(data => {      
                  this.complex.items = data.data; 
                  this.count   = data.count;
                  this.length  = Math.ceil(this.count/this.pagesize);
                  this.loading = false;
              }); 
            }
          }, 1000);          
        },
    },
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {      
                this.complex.items = data.data; 
                this.count   = data.count;
                this.length  = Math.ceil(this.count/this.pagesize);
                this.loading = false;
            });                                         
        },
                
        
    }
}
</script>